import { useEffect } from 'react';
import LoadingSpinner from '../../component/LoadingSpinner';


const ExternalRedirect = () => {
    useEffect(() => {
      // Redirect to the external URL
      //window.location.href = 'https://tnesentrymfa.auth.ap-south-1.amazoncognito.com/oauth2/authorize?client_id=l3b2no3q8178psocdvfbnkcke&response_type=code&scope=email+openid+profile&redirect_uri=https://wns-sentry-dev.sony.eu/dashboard';

      window.location.href = ' https://eu-west-1qktbytdgu.auth.eu-west-1.amazoncognito.com/login?client_id=jm03olh8l8cu404dq2t1qkjn2&response_type=code&scope=email+openid+phone&redirect_uri=https://wns-sentry-dev.sony.eu/dashboard';
    }, []);
  
    return <div><LoadingSpinner/></div>;
  };
  export default ExternalRedirect;